import LoginStarsIcon from './LoginStarsIcon';

export default LoginStarsIcon;
